import { render } from "./AddonForm.vue?vue&type=template&id=68c795f2&scoped=true"
import script from "./AddonForm.vue?vue&type=script&lang=js"
export * from "./AddonForm.vue?vue&type=script&lang=js"

import "./AddonForm.vue?vue&type=style&index=0&id=68c795f2&scoped=true&lang=css"
import "./AddonForm.vue?vue&type=style&index=1&id=68c795f2&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68c795f2"]])

export default __exports__